<div fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="12px" style="gap: 12px; width: 100%;" fxFlex.gt-md="60" fxFlex fxFlex.gt-sm>
  <mat-form-field appearance="outline" fxFlex="60" style="width: 100%;">
    <mat-label>{{field?.frontendLabel}}</mat-label>
    <input [attr.guide]="'datetime-date-inp-1' + '__' + sanitizeUrl(url)"
      [autocomplete]="'off'"
      matInput
      [matDatepicker]="picker"
      [(ngModel)]="dateValue"
      (dateChange)="onDateTimeChange()"
      [required]="isRequired" />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker disabled="false" #picker></mat-datepicker>
    <mat-error *ngIf="isInvalid">
      Please select a date.
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" fxFlex="40" style="width: 100%;">
    <mat-label>Time</mat-label>
    <input [attr.guide]="'datetime-time-inp-1' + '__' + sanitizeUrl(url)"
      type="time"
      matInput
      [(ngModel)]="timeValue"
      (input)="onDateTimeChange()"
      (change)="onDateTimeChange()"
      [required]="isRequired" />
    <mat-error *ngIf="isInvalid && !timeValue">
      Please select a time.
    </mat-error>
  </mat-form-field>
</div>
